import { Columns } from '@shared/interfaces/table/column-config';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';

/**
 * PhysicalStatus Partial Staus Cell
 * Shows physical status as a status indicator
 */
export const physicalStatusPartial: Columns<any> = {
  title: 'meter.connectivitystatus',
  key: 'physicalStatus',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    notspecified: { color: 'bg-yellow-500', label: 'enum.physicalstatus.notspecified' },
    new: { color: 'bg-yellow-500', label: 'enum.physicalstatus.new' },
    disconnected: { color: 'bg-red-500', label: 'enum.physicalstatus.disconnected' },
    connected: { color: 'bg-green-500', label: 'enum.physicalstatus.connected' },
    closeddown: { color: 'bg-red-500', label: 'enum.physicalstatus.closeddown' },
  }
}
